export default __webpack_public_path__ + "static/media/menBanner.6d50d0df.svg";